<template>
  <div class="main-graph-window">
    <div v-click-outside="closeMatrix" v-if="matrixView">
      <matrix-view-component
        :matrix-view="matrixView"
        :main-sector="mainSector"
        :sub-sector="selectedTab"
      />
    </div>
    <div class="menu-wrapper" @mouseenter="matrixView = false">
      <ul class="sub-menu-dropup">
        <li
          class="dropdown-item btn btn-block btn-light-gray"
          v-for="tab in paginate(returnGraphTabs())[tabPaginate]"
          :key="tab"
          v-if="tab.alias !== 'DIR'"
          @click="TabClick(tab)"
          @mouseenter="[(hoveringTab = tab.alias), (openSubTab = true)]"
          :class="{
            active: selectedTab === tab.alias.toUpperCase(),
            'cal-match':
              selectedCalendarType.alias === mainCalendarSection &&
              selectedTab === tab.alias
          }"
        >
          <i
            class="fas fa-times cancel-filter"
            v-if="checkFilterTab(tab.alias)"
            @click.stop="resetTabFilter(tab.alias)"
          ></i>
          <span
            class="dropdown-item-left"
            :class="{
              longTitleFontSize: tab.name.length > 6
            }"
            >{{ tab.name }}</span
          >
          <span
            class="dropdown-item-right"
            v-if="
              tab.hasOwnProperty('subMenu') || tab.hasOwnProperty('presetTabs')
            "
            ><i class="fas fa-caret-right"></i
          ></span>

          <!--          default sub menus-->
          <!--          <ul-->
          <!--            class="sub-menu-main"-->
          <!--            v-if="-->
          <!--              tab.hasOwnProperty('subMenu') &&-->
          <!--                hoveringTab === tab.alias &&-->
          <!--                selectedTab === tab.alias-->
          <!--            "-->
          <!--          >-->
          <!--            <li-->
          <!--              class="dropdown-item btn btn-block btn-light-gray"-->
          <!--              v-for="subTab in tab.subMenu"-->
          <!--              :key="subTab.id"-->
          <!--              @click.stop="clickSubTab(tab, subTab)"-->
          <!--              :class="{-->
          <!--                active: selectedSubTab === subTab.alias-->
          <!--              }"-->
          <!--            >-->
          <!--              <span class="dropdown-item-left sub">{{ subTab.name }}</span>-->
          <!--            </li>-->
          <!--          </ul>-->

          <!--          presets sub menus-->
          <!--          <ul-->
          <!--            v-click-outside="closeSubTab"-->
          <!--            class="sub-menu-main"-->
          <!--            v-if="-->
          <!--              tab.hasOwnProperty('presetTabs') &&-->
          <!--                (hoveringTab === tab.alias && openSubTab)-->
          <!--            "-->
          <!--          >-->
          <!--            <li-->
          <!--              class="dropdown-item btn btn-block btn-light-gray"-->
          <!--              v-for="subTab in statsTabs"-->
          <!--              :key="subTab.id"-->
          <!--              @click.stop="setPresetFromTab(subTab, tab, true)"-->
          <!--              :class="{-->
          <!--                active: selectedCalendarType.preset === subTab.alias-->
          <!--              }"-->
          <!--            >-->
          <!--              <span class="dropdown-item-left sub">{{ subTab.name }}</span>-->
          <!--            </li>-->
          <!--          </ul>-->
        </li>
      </ul>
      <div class="arrow-down">
        <!--        <div class="presets-container dropup">-->
        <!--&lt;!&ndash;          <button&ndash;&gt;-->
        <!--&lt;!&ndash;            class="btn btn-info pre-btn dropdown-toggle"&ndash;&gt;-->
        <!--&lt;!&ndash;            data-toggle="dropdown"&ndash;&gt;-->
        <!--&lt;!&ndash;          >&ndash;&gt;-->
        <!--&lt;!&ndash;            PRESETS&ndash;&gt;-->
        <!--&lt;!&ndash;          </button>&ndash;&gt;-->
        <!--          <div class="dropdown-menu sub-menu-presets-tab">-->
        <!--            <button-->
        <!--              class="btn btn-block preset-tab"-->
        <!--              v-for="subTab in presetsTabs"-->
        <!--              :key="subTab.id"-->
        <!--              @click.stop="setPresetFromTab(subTab, tab)"-->
        <!--              :class="{-->
        <!--                active: selectedCalendarType.preset === subTab.alias-->
        <!--              }"-->
        <!--            >-->
        <!--              {{ subTab.name }}-->
        <!--            </button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <i-->
        <!--          v-if="graphTabs.length > tabsLength"-->
        <!--          :class="{-->
        <!--            disabled_scroll: paginate(graphTabs)[tabPaginate + 1] === undefined-->
        <!--          }"-->
        <!--          class="fas fa-angle-down"-->
        <!--          @click="tabPaginate++"-->
        <!--        ></i>-->
        <!--        <i-->
        <!--          v-if="graphTabs.length > tabsLength"-->
        <!--          :class="{-->
        <!--            disabled_scroll: paginate(graphTabs)[tabPaginate - 1] === undefined-->
        <!--          }"-->
        <!--          class="fas fa-angle-up"-->
        <!--          @click="tabPaginate&#45;&#45;"-->
        <!--        ></i>-->
      </div>
    </div>
    <div class="chart-section">
      <div class="deposit-chart">
        <div class="for-presets">
          <div class="presets-container dropup">
            <!--          <button-->
            <!--            class="btn btn-info pre-btn dropdown-toggle"-->
            <!--            data-toggle="dropdown"-->
            <!--          >-->
            <!--            PRESETS-->
            <!--          </button>-->
            <div class="dropdown-menu sub-menu-presets-tab">
              <button
                class="btn btn-block preset-tab"
                v-for="subTab in presetsTabs"
                :key="subTab.id"
                @click.stop="setPresetFromTab(subTab, tab)"
                :class="{
                  active: validPreset(mainCalendarSection) === subTab.alias
                }"
              >
                {{ subTab.name }}
              </button>
              <button
                class="btn btn-block preset-tab stats-btn"
                @click="setMatrixView(selectedTab)"
                v-if="checkForMatrix(selectedTab)"
              >
                STATS
              </button>
            </div>
            <div class="top-bar" v-if="counters.users > 0">
              <div class="inner-bar">total tr: {{ counters.tr }}</div>
              <div class="inner-bar">total users: {{ counters.users }}</div>
              <div class="inner-bar" v-if="trDates">
                dates:
                {{ trDates[0] }} -
                {{ trDates[1] }}
                <span class="for-diff-in-days">{{ trDates[2] }}</span>
              </div>
            </div>
          </div>
        </div>
        <canvas class="trans-chart" id="main-chart-transfers"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "../../../../../../helpers/api/request";
import Chart from "chart.js";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment/moment";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CahartAnnot from "chartjs-plugin-annotation";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import vClickOutside from "v-click-outside";
import MatrixViewComponent from "@/features/company.feature/sub_features.company/graph.sub-feature.company/components/matrix_view/MatrixViewComponent";
import presetsValidator from "@/mixins/presets/presetsValidator";

const StatusBar = {
  type: "bar",
  options: {
    animation: {
      duration: 0
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            //display:false,
            beginAtZero: true,
            padding: 15,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },
    // legend: {
    //     position: "top",
    //     align: "end",
    //     labels: {
    //         boxWidth: 20,
    //         fontSize: 10,
    //         display: false
    //     },
    //     onHover: function(e) {
    //         e.target.style.cursor = 'pointer';
    //     }
    // },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};
const transferToChartOpt = {
  type: "bar",
  options: {
    layout: {
      padding: {
        top: 2
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.4)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 15,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    /*    legend: {
      display: false
    }*/
    legend: {
      position: "top",
      align: "end",
      labels: {
        boxWidth: 20,
        fontSize: 10
        // display: false
      },
      onHover: function(e) {
        e.target.style.cursor = "pointer";
      }
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};
const transferVolChartOpt = {
  type: "line",
  options: {
    layout: {
      padding: {
        top: 2
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return "#44A2D2";
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.4)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            //display:false,
            beginAtZero: true,
            padding: 15,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      position: "top",
      align: "end",
      // onClick:function(value,index){
      //   let id = index.datasetIndex;
      //   this.volLabelIndex[id] = index.hidden;
      //   this.createTransferVolChart(
      //           "line-chart-trans-vol",
      //           this.transferVolChartOpt,
      //           this.tranVolStats,
      //           this.volLabelIndex
      //   );
      //
      // },
      labels: {
        boxWidth: 20,
        fontSize: 10
        // display: false
      },
      onHover: function(e) {
        e.target.style.cursor = "pointer";
      }
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};

export default {
  name: "TransfersCharts.component",
  mixins: [UsersPermissionCheck,presetsValidator],
  props: {
    mainData: {
      required: true,
      type: Object
    },
    mainSector: {
      required: true,
      type: String
    },
    tabs: {
      type: Array,
      required: true
    },
    presetsTabs: {
      type: Array,
      required: true
    },
    statsTabs: {
      type: Array,
      required: true
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    MatrixViewComponent
  },
  computed: {
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "multiSelectChartData",
      "selectedCalendarType",
      "generalQueryObject",
      "showReset",
      "clickFromChart"
    ]),
    ...mapGetters("clients", ["getMultiSelectChartData"])
  },
  data() {
    return {
      StatusBar: StatusBar,
      transferToChartOpt: transferToChartOpt,
      transferVolChartOpt: {
        type: "line",
        options: {
          layout: {
            padding: {
              top: 2
            }
          },
          plugins: {
            datalabels: {
              align: "end",
              anchor: "end",
              offset: -5,

              font: {
                family: "Montserrat"
              },
              fontSize: 9,
              color: function(context) {
                return "#44A2D2";
              },
              formatter: function(value) {
                return value === 0 ? "" : value;
              }
            }
          },

          maintainAspectRatio: false,
          gradientColors: [
            "rgba(29,140,248,0.4)",
            "rgba(29,140,248,0.0)",
            "rgba(29,140,248,0)"
          ],
          gradientStops: [1, 0.4, 0],
          responsive: true,
          scales: {
            yAxes: [
              {
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
                },
                ticks: {
                  //display:false,
                  beginAtZero: true,
                  padding: 15,
                  fontColor: "transparent", //"#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 1
                }
              }
            ],
            xAxes: [
              {
                id: "bar-x-axis1",
                // barPercentage: 1.0,
                // categoryPercentage: 0.5,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent"
                },
                ticks: {
                  padding: 0,
                  fontColor: "#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 10
                }
              }
            ]
          },
          legend: {
            position: "top",
            align: "end",
            onClick: (value, index) => {
              let id = index.datasetIndex;

              this.updateTransVolChart(id, index);
            },
            labels: {
              boxWidth: 20,
              fontSize: 10
              // display: false
            },
            onHover: function(e) {
              e.target.style.cursor = "pointer";
            }
          },
          hover: {
            onHover: function(e) {
              const point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = "pointer";
              else e.target.style.cursor = "default";
            }
          }
        }
      },
      transToChart: null,
      transByChart: null,
      transVolChart: null,

      tranToUsersStats: [],
      requestTranToUsersBusy: false,

      tranByUsersStats: [],
      requestTranByUsersBusy: false,

      tranVolStats: {},
      requestTranVolUsersBusy: false,

      volLabelIndex: [true, true, false],
      queryParams: {},

      mainCalendarSection: "TRA",
      hoveringTab: false,
      transfersChartTab: null,
      selectedTab: "",
      tabPaginate: 0,
      tabsLength: 8,
      requestsForTabs: {},

      ext_tabs: [
        {
          id: 1,
          name: "VOLATILITY",
          alias: "VOL",
          ex: true
        }
      ],
      graphTabs: [],
      matrixView: false,
      counters: {
        tr: 0,
        users: 0
      },
      trDates: null
    };
  },
  created() {
    this.graphTabs = this.tabs;
    this.selectedTab = this.graphTabs[0].alias.toUpperCase();
  },
  watch: {
    multiSelectChartData: {
      handler() {
        // if (this.transfersChartTab) {
        //   this.transfersChartTab.destroy();
        // }
        this.initialChartData(this.getMultiSelectChartData);
      },
      deep: true
    }
  },
  methods: {
    diffTimeInDaysForNaChartTitle(d1, d2) {
      let date1 = new Date(d1);
      let date2 = new Date(d2);
      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays + 1 + "Days";
    },
    async initialChartData(data) {
      // if (this.transfersChartTab) {
      //   this.transfersChartTab.destroy();
      // }
      if (this.mainSector === data.selectedSector) {
        if (data.data[this.mainSector].selectedTab.toUpperCase() !== "DIR") {
          let element = document.getElementsByClassName(
            "dropdown-item btn btn-block btn-light-gray active"
          );
          $(element).removeClass("loading");
          if (data.fromChart) {
            return;
          }
          let tab = this.ext_tabs.filter(tab => {
            return tab.alias === this.selectedTab;
          });
          if (tab.length > 0) {
            await this.fetchExternalGraphs(tab[0]);
            return;
          }
          // this.$store.commit("clients/setSelectedCalendarType", {
          //   alias: this.mainCalendarSection,
          //   preset: null
          // });
          this.mainSector = data.selectedSector;
          this.allData = data;
          this.chartData = data.data[this.mainSector].data;
          this.selectedTab = data.data[
            this.mainSector
          ].selectedTab.toUpperCase();
          let lineChartStatus = `main-chart-transfers`;
          if (this.transfersChartTab) {
            this.transfersChartTab.destroy();
          }
          if (!this.chartData.hasOwnProperty(this.mainSector)) {
            this.createChart(
              lineChartStatus,
              this.StatusBar,
              this.chartData,
              this.selectedTab
            );
          }
        }
      }
    },
    async TabClick(tab) {
      if (
        (!tab.hasOwnProperty("ex") && !tab.ex) ||
        (tab.hasOwnProperty("ex") &&
          tab.hasOwnProperty("combine") &&
          tab.combine)
      ) {
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        // if (this.selectedTab !== tab.alias) {
        //   this.$store.commit("clients/setSelectedCalendarType", {
        //     alias: this.mainCalendarSection,
        //     preset: null
        //   });
        // }
        let element = document.getElementsByClassName(
          "dropdown-item btn btn-block btn-light-gray active"
        );
        $(element).addClass("loading");
        this.selectedTab = tab.alias;
        let data = Object.assign({}, this.allData);
        data.selectedTab = tab.alias;
        data.fromChart = true;
        this.$store.commit("clients/setMultiSelectChartData", [
          data,
          this.mainSector
        ]);
      }
      if (tab.hasOwnProperty("ex") && tab.ex) {
        this.selectedTab = tab.alias;
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        await this.fetchExternalGraphs(tab);
      }
    },
    checkForMatrix(mainTab) {
      let allTabs = [...this.tabs, ...this.ext_tabs];
      return allTabs.find(tab => {
        return tab.alias === mainTab && tab.hasOwnProperty("presetTabs");
      });
    },

    clickSubTab(mainTab, subTab) {
      this.openSubTab = true;
      this.selectedSubTab = subTab.alias;

      //functions of sub tabs

      if (subTab.hasOwnProperty("presetTab") && subTab.presetTab) {
        if (this.selectedSubTab === "MATRIX") {
          this.setPresetFromTab(subTab);
          this.TabClick(mainTab);
        }

        return;
      }
    },

    createChart(chartId, chartOpt, stats) {
      let opt = chartOpt.options;
      const NewData = stats;
      let labels = [];
      let onlineCounts = [];
      let ids = [];
      if (NewData && NewData.length > 0) {
        NewData.forEach(num1 => {
          if (num1.count[0] === 0) {
            return;
          }
          labels.push(num1.title.substring(0, 17));
          onlineCounts.push(num1.count[0]);
          ids.push(num1.id);
        });
      }

      if (this.generalQueryObject.hasOwnProperty("last_transfer_from")) {
        this.trDates = [
          this.generalQueryObject.last_transfer_from
            .split("-")
            .reverse()
            .join("-"),
          this.generalQueryObject.last_transfer_to
            .split("-")
            .reverse()
            .join("-"),
          this.diffTimeInDaysForNaChartTitle(
            this.generalQueryObject.last_transfer_from,
            this.generalQueryObject.last_transfer_to
          )
        ];
      } else {
        this.trDates = null;
      }
      this.counters.tr = onlineCounts.reduce((a, b) => a + b, 0);
      this.counters.users = onlineCounts.length;

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Count",
            data: onlineCounts, //onlineTrans,
            fill: true,
            borderColor: "rgb(130, 119, 23)",
            backgroundColor: "rgb(130, 119, 23,0.5)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1"
          }
        ]
      };

      if (this.transfersChartTab) {
        this.transfersChartTab.destroy();
      }
      if (onlineCounts.length > 0) {
        opt.annotation = this.returnAverageLine(
          onlineCounts.reduce((a, b) => a + b) / onlineCounts.length,
          true,
          "rgb(106,93,12)",
          350
        );
      }

      const ctx = document.getElementById(chartId);
      this.transfersChartTab = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
      ctx.onclick = evt => {
        this.clickOnChart(this.transfersChartTab, evt, ids);
      };
    },

    namesFormatter(name, numLet = 3) {
      let first_name = name.split(" ")[0].substring(0, numLet);
      let second_name = "";
      name.split(" ").length > 1
        ? (second_name = name
            .split(" ")[1]
            .substring(0, 1)
            .toUpperCase())
        : (second_name = "");
      let fullName = first_name + " " + second_name;
      return fullName;
    },

    async fetchExternalGraphs(subSector) {
      if (this.transfersChartTab) {
        this.transfersChartTab.destroy();
      }
      let tab = subSector.alias;
      let element = document.getElementsByClassName(
        "dropdown-item btn btn-block btn-light-gray active"
      );
      $(element).addClass("loading");
      this.depUsersStatsToday = [];
      this.requestsForTabs[tab] = true;
      if (!this.showReset) {
        this.resetMainFilters();
      } else {
        this.mainFilters = this.generalQueryObject;
      }
      if (this.selectedTab === "VOL") {
        await this.fetchTransfersVolStats();
      }

      //functions for ext tabs

      this.requestsForTabs[tab] = false;
      $(element).removeClass("loading");
    },

    updateTransVolChart(id, index) {
      if (index.hidden) {
        this.volLabelIndex[id] = false;
      } else {
        this.volLabelIndex[id] = true;
      }

      this.createTransferVolChart(
        "main-chart-transfers",
        this.transferVolChartOpt,
        this.tranVolStats,
        this.volLabelIndex
      );
    },

    returnGraphTabs() {
      let tabs = this.graphTabs;
      if (
        this.generalQueryObject.hasOwnProperty("last_transfer_from") &&
        this.generalQueryObject.hasOwnProperty("last_transfer_to") &&
        this.CheckUserPermission([1, 2, 3, 4, 5, 12])
      ) {
        tabs = [...tabs, ...this.ext_tabs];
      }
      return tabs;
    },
    returnDualAverageLine: (
      avgA,
      avgB,
      enabledA,
      enabledB,
      colorA,
      colorB
    ) => ({
      annotations: [
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: avgA,
          borderColor: colorA,
          borderWidth: 1,
          borderDash: [2, 2],
          label: {
            backgroundColor: "rgba(0,0,0,0.0)",
            fontFamily: "Montserrat",
            fontSize: 10,
            fontStyle: "bold",
            fontColor: "#000",
            xPadding: 4,
            yPadding: 4,
            cornerRadius: 5,
            position: "right",
            xAdjust: 15,
            yAdjust: -10,
            enabled: enabledA,
            content: avgA.toFixed(0),
            rotation: 90
          }
        },
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: avgB,
          borderColor: colorB,
          borderWidth: 1,
          borderDash: [2, 2],
          label: {
            backgroundColor: "rgba(0,0,0,0.0)",
            fontFamily: "Montserrat",
            fontSize: 10,
            fontStyle: "bold",
            fontColor: "#000",
            xPadding: 4,
            yPadding: 4,
            cornerRadius: 5,
            position: "left",
            xAdjust: 5,
            yAdjust: -10,
            enabled: enabledB,
            content: avgB.toFixed(0),
            rotation: 90
          }
        }
      ]
    }),

    createTransferToChart(chartId, chartOpt, stats) {
      let opt = chartOpt.options;
      const onlineData = stats.online;
      const liveData = stats.live;
      let labels = [];
      let onlineTrans = [];
      let liveTrans = [];

      /*
    onlineData.sort((a, b) => {
        if (a.count > b.count) {
          return -1;
        }
        if (a.count < b.count) {
          return 1;
        }
        return 0;
      });
      liveData.sort((a, b) => {
        if (a.count > b.count) {
          return -1;
        }
        if (a.count < b.count) {
          return 1;
        }
        return 0;
      });
*/

      onlineData.forEach((num1, index) => {
        const num2 = liveData[index];
        if (num2.count === 0 && num1.count === 0) {
          return;
        }
        // if (
        //   (num1.user.id === 22 && num2.user.id === 22) ||
        //   (num1.user.id === 77 && num2.user.id === 77) ||
        //   (num1.user.id === 43 && num2.user.id === 43) ||
        //   (num1.user.id === 36 && num2.user.id === 36) ||
        //   (num1.user.id === 89 && num2.user.id === 89) ||
        //   (num1.user.id === 88 && num2.user.id === 88) ||
        //   (num1.user.id === 29 && num2.user.id === 29) ||
        //   (num1.user.id === 86 && num2.user.id === 86)
        // ) {
        //   return;
        // } //TODO: replaced by server side stats_active filtering - do not delete this section

        labels.push(this.namesFormatter(num1.user.full_name));
        onlineTrans.push(num1.count);
        liveTrans.push(num2.count);
      });

      //opt.annotation = this.returnAverageLine(1, false);
      opt.annotation = this.returnDualAverageLine(
        onlineTrans.reduce((a, b) => a + b) / onlineTrans.length,
        liveTrans.reduce((a, b) => a + b) / liveTrans.length,
        true,
        true,
        "rgb(0,245,0,0.4)",
        "rgba(234,209,0,0.4)"
      );

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Live",
            data: liveTrans,
            fill: true,
            borderColor: "rgba(130,119,23)",
            backgroundColor: "rgba(234,209,0,0.4)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            //  maxBarThickness: 20,
            xAxisID: "bar-x-axis1"
          },
          {
            type: "bar",
            label: "Online",
            data: onlineTrans,
            fill: true,
            borderColor: "rgb(0,139,0)",
            backgroundColor: "rgba(0,245,0,0.4)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            //  maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            hidden: true
          }
        ]
      };
      if (this.transToChart) {
        this.transToChart.destroy();
      }
      const ctx = document.getElementById(chartId);
      this.transToChart = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
      Chart.Legend.prototype.afterFit = function() {
        this.height = this.height + 5;
      };
    },
    createTransferByChart(chartId, chartOpt, stats) {
      let opt = chartOpt.options;
      const onlineData = stats.online;
      const liveData = stats.live;
      let labels = [];
      let onlineTrans = [];
      let liveTrans = [];

      /*      onlineData.sort((a, b) => {
        if (a.count > b.count) {
          return -1;
        }
        if (a.count < b.count) {
          return 1;
        }
        return 0;
      });
      liveData.sort((a, b) => {
        if (a.count > b.count) {
          return -1;
        }
        if (a.count < b.count) {
          return 1;
        }
        return 0;
      });*/

      onlineData.forEach((num1, index) => {
        const num2 = liveData[index];
        if (num2.count === 0 && num1.count === 0) {
          return;
        }
        // if (
        //   (num1.user.id === 22 && num2.user.id === 22) ||
        //   (num1.user.id === 77 && num2.user.id === 77) ||
        //   (num1.user.id === 43 && num2.user.id === 43) ||
        //   (num1.user.id === 36 && num2.user.id === 36) ||
        //   (num1.user.id === 89 && num2.user.id === 89) ||
        //   (num1.user.id === 88 && num2.user.id === 88) ||
        //   (num1.user.id === 29 && num2.user.id === 29) ||
        //   (num1.user.id === 86 && num2.user.id === 86)
        // ) {
        //   return;
        // } //TODO: replaced by server side stats_active filtering - do not delete this section
        labels.push(this.namesFormatter(num1.user.full_name));
        onlineTrans.push(num1.count);
        liveTrans.push(num2.count);
      });

      opt.annotation = this.returnDualAverageLine(
        onlineTrans.reduce((a, b) => a + b) / onlineTrans.length,
        liveTrans.reduce((a, b) => a + b) / liveTrans.length,
        true,
        true,
        "rgba(234,209,0,0.4)",
        "rgba(0,245,0,0.4)"
      );

      const data = {
        labels: labels,
        datasets: [
          {
            type: "bar",
            label: "Live",
            data: liveTrans,
            fill: true,
            borderColor: "rgba(130,119,23)",
            backgroundColor: "rgba(234,209,0,0.4)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 50,
            xAxisID: "bar-x-axis1"
          },
          {
            type: "bar",
            label: "Online",
            data: onlineTrans,
            fill: true,
            borderColor: "rgb(0,139,0)",
            backgroundColor: "rgba(0,245,0,0.4)",
            borderWidth: 0.5,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 50,
            xAxisID: "bar-x-axis1",
            hidden: true
          }
        ]
      };

      if (this.transByChart) {
        this.transByChart.destroy();
      }
      const ctx = document.getElementById(chartId);
      this.transByChart = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
      Chart.Legend.prototype.afterFit = function() {
        this.height = this.height + 5;
      };
    },

    createTransferVolChart(chartId, chartOpt, stats, labelIndex) {
      let opt = chartOpt.options;
      const volData = stats;
      let labels = [];
      let transVolatilityLive = [];
      let transVolatilityOnline = [];
      let transVolatilitySum = [];

      if (this.transVolChart) {
        this.transVolChart.destroy();
      }

      volData.online_transfer.forEach((num1, index) => {
        let num2 = volData.live_transfer.find(a => a.date === num1.date);
        if (!num2) {
          num2 = { count: 0, date: num1.date };
        }

        /*   if (num2.count === 0 && num1.count === 0) {
          return;
        }*/

        // const start = this.transferChartDateRange.start;
        // const end = this.transferChartDateRange.end;
        // if (moment(start).diff(end, "days") === 0) {
        //   if (num2.count === 0 && num1.count === 0) {
        //     return;
        //   }
        // } else {
        //   if (
        //     (num2.count === 0 && num1.count === 0) ||
        //     (num1.count < 5 && num2.count < 5)
        //   ) {
        //     return;
        //   }
        // }

        labels.push(num1.date);
        transVolatilityOnline.push(num1.count);
        transVolatilityLive.push(num2.count);

        transVolatilitySum.push(num1.count + num2.count);
      });

      /*
      volData.live_transfer.forEach(item => {
        //  if(this.transferChartDateRange.hasOwnProperty("start") &&this.transferChartDateRange.hasOwnProperty("end") ) {
        const start = this.transferChartDateRange.start;
        const end = this.transferChartDateRange.end;
        if (moment(start).diff(end, "days") === 0) {
          if (item.count === 0) {
            return;
          }
        } else {
          if (item.count === 0 || item.count < 5) {
            return;
          }
        }

        labels.push(item.date);
        transVolatilityLive.push(item.count);
      });
*/

      // if (transVolatilityLive.length > 0) {
      //   /*        opt.annotation = this.returnAverageLine(
      //           transVolatilityLive.reduce((a, b) => a + b) / transVolatilityLive.length,
      //     true,"rgb(102,193,233)"
      //   );*/
      //
      //   opt.annotation = this.returnDualAverageLine(
      //     transVolatilityOnline.reduce((a, b) => a + b) /
      //       transVolatilityOnline.length,
      //     transVolatilityLive.reduce((a, b) => a + b) /
      //       transVolatilityLive.length,
      //     true,
      //     true,
      //     "rgb(0,139,0,06)",
      //     "rgba(130,119,23,0.7)"
      //   );
      // }
      opt.annotation = null;
      if (!labelIndex[0]) {
        if (transVolatilityLive.length > 0) {
          opt.annotation = this.returnNewAverageLine(
            transVolatilityLive.reduce((a, b) => a + b) /
              transVolatilityLive.length,
            true,
            "rgb(130,119,23,0.4)",
            255
          );
        }
      }

      if (!labelIndex[1]) {
        if (transVolatilityOnline.length > 0) {
          if (opt.annotation) {
            opt.annotation.annotations.push(
              this.returnNewAverageLine(
                transVolatilityOnline.reduce((a, b) => a + b) /
                  transVolatilityOnline.length,
                true,
                "rgb(0,139,0,0.4)",
                430
              ).annotations[0]
            );
          } else {
            opt.annotation = this.returnNewAverageLine(
              transVolatilityOnline.reduce((a, b) => a + b) /
                transVolatilityOnline.length,
              true,
              "rgb(0,139,0,0.4)",
              430
            );
          }
        }
      }

      const data = {
        labels: labels,
        datasets: [
          {
            type: "line",
            label: "Live",
            fill: false,
            borderColor: "rgb(130,119,23,0.4)", //"rgba(186,231,85,0.9)",
            borderWith: 2,
            backgroundColor: "#e755ba",
            pointBackgroundColor: "rgba(80,71,14,0.4)",
            pointBorderColor: "rgba(80,71,14,0.4)",
            pointHoverBackgroundColor: "rgba(80,71,14,0.4)",
            pointHoverBorderColor: "rgba(80,71,14,0.4)",
            data: transVolatilityLive,
            hidden: labelIndex[0]
          },
          {
            type: "line",
            label: "Online",
            fill: false,
            borderColor: "rgb(0,139,0,0.6)", //"rgba(186,231,85,0.9)",
            borderWith: 2,
            backgroundColor: "#e755ba",
            pointBackgroundColor: "rgb(0,139,0,0.6)",
            pointBorderColor: "rgb(0,139,0,0.6)",
            pointHoverBackgroundColor: "rgb(0,139,0,0.6)",
            pointHoverBorderColor: "rgb(0,139,0,0.6)",
            data: transVolatilityOnline,
            hidden: labelIndex[1]
          },
          {
            type: "line",
            label: "SUM",
            fill: false,
            borderColor: "rgba(233,30,99,0.6)", //"rgba(186,231,85,0.9)",
            borderWith: 2,
            backgroundColor: "#e755ba",
            pointBackgroundColor: "rgba(154,0,52,0.6)",
            pointBorderColor: "rgba(154,0,52,0.6)",
            pointHoverBackgroundColor: "rgba(154,0,52,0.6)",
            pointHoverBorderColor: "rgba(154,0,52,0.6)",
            data: transVolatilitySum,
            hidden: labelIndex[2]
          }
        ]
      };

      const ctx = document.getElementById(chartId);
      this.transVolChart = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
      Chart.Legend.prototype.afterFit = function() {
        this.height = this.height + 5;
      };
    },

    async fetchTransfersToStats() {
      this.tranToUsersStats = [];
      if (!this.requestTranToUsersBusy) {
        this.requestTranToUsersBusy = true;

        let queryParamsToLive = Object.assign({}, this.queryParams);
        queryParamsToLive.transfer = 1;
        queryParamsToLive.client_transfers_type = [1];
        //queryParamsToLive.special_req = true;

        // if (
        //   queryParamsToLive.hasOwnProperty("last_transfer_from") &&
        //   queryParamsToLive.hasOwnProperty("last_transfer_to")
        // ) {
        //   queryParamsToLive.last_transfer_from = moment(
        //     this.transferChartDateRange.start
        //   ).format("YYYY-MM-DD");
        //   queryParamsToLive.last_transfer_to = moment(
        //     this.transferChartDateRange.end
        //   ).format("YYYY-MM-DD");
        // }
        let queryParamsToOnline = Object.assign({}, this.queryParams);

        queryParamsToOnline.transfer = 1;
        queryParamsToOnline.client_transfers_type = [2];
        //   queryParamsToOnline.special_req = true;
        // if (
        //   this.transferChartDateRange.hasOwnProperty("start") &&
        //   this.transferChartDateRange.hasOwnProperty("end")
        // ) {
        //   queryParamsToOnline.last_transfer_from = moment(
        //     this.transferChartDateRange.start
        //   ).format("YYYY-MM-DD");
        //   queryParamsToOnline.last_transfer_to = moment(
        //     this.transferChartDateRange.end
        //   ).format("YYYY-MM-DD");
        // }

        const liveTransfer = await apiClientCreator(
          `client/stats/tag/tr/0/0`
        ).get("", { params: queryParamsToLive });
        const onlineTransfer = await apiClientCreator(
          `client/stats/tag/tr/0/0`
        ).get("", { params: queryParamsToOnline });
        this.tranToUsersStats = {
          live: liveTransfer.data,
          online: onlineTransfer.data
        };

        this.createTransferToChart(
          "line-chart-trans-to",
          this.transferToChartOpt,
          this.tranToUsersStats
        );
        this.requestTranToUsersBusy = false;
      }
    },

    async fetchTransfersByStats() {
      this.tranByUsersStats = [];
      if (!this.requestTranByUsersBusy) {
        this.requestTranByUsersBusy = true;
        // const id = this.tranByUsersStats.length;

        const queryParamsByLive = Object.assign({}, this.queryParams);

        queryParamsByLive.transfer = 1;
        queryParamsByLive.client_transfers_type = [1];

        // if (
        //   this.transferChartDateRange.hasOwnProperty("start") &&
        //   this.transferChartDateRange.hasOwnProperty("end")
        // ) {
        //   queryParamsByLive.last_transfer_from = moment(
        //     this.transferChartDateRange.start
        //   ).format("YYYY-MM-DD");
        //   queryParamsByLive.last_transfer_to = moment(
        //     this.transferChartDateRange.end
        //   ).format("YYYY-MM-DD");
        // }

        const queryParamsByOnline = Object.assign({}, this.queryParams);

        queryParamsByOnline.transfer = 1;
        queryParamsByOnline.client_transfers_type = [2];

        // if (
        //   this.transferChartDateRange.hasOwnProperty("start") &&
        //   this.transferChartDateRange.hasOwnProperty("end")
        // ) {
        //   queryParamsByOnline.last_transfer_from = moment(
        //     this.transferChartDateRange.start
        //   ).format("YYYY-MM-DD");
        //   queryParamsByOnline.last_transfer_to = moment(
        //     this.transferChartDateRange.end
        //   ).format("YYYY-MM-DD");
        // }

        const liveTransfer = await apiClientCreator(
          `client/stats/tag/tr/0/2`
        ).get("", { params: queryParamsByLive });
        const onlineTransfer = await apiClientCreator(
          `client/stats/tag/tr/0/2`
        ).get("", { params: queryParamsByOnline });

        this.tranByUsersStats = {
          live: liveTransfer.data,
          online: onlineTransfer.data
        };
        this.createTransferByChart(
          "line-chart-trans-by",
          this.transferToChartOpt,
          this.tranByUsersStats
        );
        this.requestTranByUsersBusy = false;
      }
    },
    async fetchTransfersVolStats() {
      this.tranVolStats = [];
      if (!this.requestTranVolUsersBusy) {
        this.requestTranVolUsersBusy = true;
        const queryParamsByLive = Object.assign({}, this.generalQueryObject);

        queryParamsByLive.transfer = 1;

        const dateTransfer = await apiClientCreator(
          `client/stats/calendar/trans/vol`
        ).get("", { params: queryParamsByLive });

        this.tranVolStats = dateTransfer.data;
        this.createTransferVolChart(
          "main-chart-transfers",
          this.transferVolChartOpt,
          this.tranVolStats,
          this.volLabelIndex
        );
        this.requestTranVolUsersBusy = false;
      }
    },
    returnNewAverageLine: (avg, enabled, lineColor, pose) => ({
      annotations: [
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: avg,
          borderColor: lineColor,
          borderWidth: 2,
          label: {
            // Background color of label, default below
            backgroundColor: lineColor,

            // Font family of text, inherits from global
            fontFamily: "Montserrat",

            // Font size of text, inherits from global
            fontSize: 10,

            // Font style of text, default below
            fontStyle: "bold",

            // Font color of text, default below
            fontColor: "#fff",

            // Padding of label to add left/right, default below
            xPadding: 4,

            // Padding of label to add top/bottom, default below
            yPadding: 4,

            // Radius of label rectangle, default below
            cornerRadius: 5,

            // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
            position: "center",

            // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
            // For horizontal lines positioned left or right, negative values move
            // the label toward the edge, and positive values toward the center.
            xAdjust: pose,

            // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
            // For vertical lines positioned top or bottom, negative values move
            // the label toward the edge, and positive values toward the center.

            yAdjust: -10,

            // Whether the label is enabled and should be displayed
            enabled: enabled,

            // Text to display in label - default is null. Provide an array to display values on a new line
            content: avg.toFixed(0),

            // Rotation of label, in degrees, default is 0
            rotation: 90
          }
        },

        {}
      ]
    }),
    returnAverageLine: (avg, enabled, lineColor, pose, YAdjust = -10) => ({
      annotations: [
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: avg,
          borderColor: lineColor,
          borderWidth: 1,
          borderDash: [2, 2],
          label: {
            // Background color of label, default below
            backgroundColor: "rgba(0,0,0,0)",

            // Font family of text, inherits from global
            fontFamily: "Montserrat",

            // Font size of text, inherits from global
            fontSize: 10,

            // Font style of text, default below
            // fontStyle: "bold",

            // Font color of text, default below
            fontColor: "#000",

            // Padding of label to add left/right, default below
            xPadding: 4,

            // Padding of label to add top/bottom, default below
            yPadding: 4,

            // Radius of label rectangle, default below
            cornerRadius: 5,

            // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
            position: "center",

            // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
            // For horizontal lines positioned left or right, negative values move
            // the label toward the edge, and positive values toward the center.
            xAdjust: pose,

            // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
            // For vertical lines positioned top or bottom, negative values move
            // the label toward the edge, and positive values toward the center.

            yAdjust: YAdjust,

            // Whether the label is enabled and should be displayed
            enabled: enabled,

            // Text to display in label - default is null. Provide an array to display values on a new line
            content: avg.toFixed(0),

            // Rotation of label, in degrees, default is 0
            rotation: 90
          }
        },

        {}
      ]
    }),
    defaultPresets(range = this.globalDateRange) {
      if (range === "TODAY") {
        const n = new Date();
        const today = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          start: today,
          end: today
        };
      }
      if (range === "YESTERDAY") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1)
        );
        // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "WEEK") {
        const n = new Date();
        const start = moment()
          .startOf("isoWeek")
          .toDate();
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "MONTH") {
        const n = new Date();
        const startMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1));
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() - 1, 1)
        );
        const endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }

      if (range === "LAST_30_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 30)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_90_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 90)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_180_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 180)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "TOMORROW") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() + 1)
        );
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "NEXT_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 1)
        );
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 2, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
    },

    paginate(stats) {
      let pageSize = this.tabsLength;

      let inputArray = stats;

      let result = inputArray.reduce((resultArray, item, index) => {
        const pageIndex = Math.floor(index / pageSize);

        if (!resultArray[pageIndex]) {
          resultArray[pageIndex] = []; // start a new page
        }

        resultArray[pageIndex].push(item);

        return resultArray;
      }, []);

      return result;
    },
    resetMainFilters() {
      this.mainFilters = {
        deposit_at_from: moment(this.defaultPresets().start).format(
          "YYYY-MM-DD"
        ),
        deposit_at_to: moment(this.defaultPresets().end).format("YYYY-MM-DD"),
        special_req: true
      };
    },

    setPresetFromTab(subTab, mainTab, setTab = null) {
      if (subTab.presetTab) {
        this.$store.commit("clients/setSelectedCalendarType", {
          alias: this.mainCalendarSection,
          preset: subTab.alias
        });
      } else {
        this.setMatrixView(mainTab);
      }

      if (setTab) {
        if (this.selectedTab !== mainTab.alias) {
          this.TabClick(mainTab);
        }
      }
    },
    setMatrixView(tab) {
      this.matrixView = true;
    },
    closeMatrix() {
      this.matrixView = false;
    },

    resetTabFilter(subTab) {
      let tab = subTab.toUpperCase();
      let mainObj = Object.assign({}, this.clickFromChart);
      if (mainObj.data.hasOwnProperty(this.mainSector)) {
        mainObj.data[this.mainSector][tab] = false;
      } else {
        mainObj.data[this.mainSector] = {
          [tab]: false
        };
      }
      mainObj.lastSector = this.mainSector;
      mainObj.subSector = this.selectedTab;
      this.$store.commit("clients/setClickFromChart", mainObj);
    },
    checkFilterTab(subTab) {
      let tab = subTab.toUpperCase();
      let mainObj = Object.assign({}, this.clickFromChart);
      if (mainObj.data.hasOwnProperty(this.mainSector)) {
        if (mainObj.data[this.mainSector].hasOwnProperty(tab)) {
          if (mainObj.data[this.mainSector][tab]) {
            return true;
          }
        }
      }
      return false;
    },
    clickOnChart(chart, evt, ids) {
      let activePoints = chart.getElementAtEvent(evt);
      if (activePoints[0]) {
        let idx = activePoints[0]["_index"];
        let selectedId = ids[idx];
        let mainObj = Object.assign({}, this.clickFromChart);
        if (mainObj.data.hasOwnProperty(this.mainSector)) {
          mainObj.data[this.mainSector][this.selectedTab] = [
            { id: selectedId }
          ];
        } else {
          mainObj.data[this.mainSector] = {
            [this.selectedTab]: [{ id: selectedId }]
          };
        }
        mainObj.lastSector = this.mainSector;
        mainObj.subSector = this.selectedTab;
        this.$store.commit("clients/setClickFromChart", mainObj);
      }
    },

    closeSubTab() {
      this.openSubTab = false;
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  text-transform: uppercase;
}
.main-graph-window {
  width: 100%;
  min-height: 200px;
  background-color: #fff;
  //padding-top: 5px;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
}
.menu-wrapper {
  overflow-x: visible;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 12px;
  /*padding-top: 12px;*/
  padding-right: 12px;
  /*padding-bottom: 12px;*/
  padding-left: 12px;
}
.dropdown-item {
  height: 35px;
  min-height: 8%;
  /*  //padding: 1px 0px;
  //margin: 0px;*/
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  border-radius: 0px 5px 5px 0px;
  //margin-bottom: 1px;
  background-color: white;
  border: 1px solid #e5e4e4;
  position: relative;
  z-index: 1;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-item.cal-match {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  margin-right: 36px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 95px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
}

.dropdown-item-left {
  margin-left: 10px;
  /*float: left;*/
  flex: 1;
  font-weight: 500;
}
.dropdown-item-right {
  width: 17px;
}
.chart-section {
  flex: 2;
  width: 92%;
  min-height: 100%;
  max-height: 200px;
  display: flex;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
}
.deposit-chart {
  width: 100%;
  min-height: 100%;
}
.longTitleFontSize {
  font-size: 11px;
}
li.active {
  background-color: #827717;
  color: #fff;
}
.sized_chart {
  max-width: 74%;
  position: relative;
}
.trans-dep-chart {
  position: relative;
  max-width: 13%;
  min-width: 13%;
  max-height: 100%;
  margin-left: 3px;
}
.dep-goal-chart {
  position: relative;
  max-width: 9%;
  min-width: 9%;
  max-height: 100%;
  margin-left: 3px;
}

.sub-menu-main {
  left: 55px;
  top: -1px;
  position: absolute;
  display: flex;
  max-height: 20px;
}
.sub-menu-main li {
  background-color: #efefef;
  color: #0a0a0a;
  cursor: pointer;
  transform: none !important;
  max-height: 20px;
  margin-left: 1px;
  border-radius: 5px;
}
.sub-menu-main li:hover {
  background-color: #dedede;
}
.sub-menu-main li.active {
  background-color: #827717;
  color: #fff;
}

.dropdown-item-left.sub {
  margin-left: unset;
  width: 50px;
  text-align: center;
}
li.loading {
  background: linear-gradient(-45deg, #827717, #4e460e, #827717, #4e460e);
  background-size: 500% 500%;
  animation: gradient 3s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 0%;
  }
  //50% {
  //  background-position: 100% 50%;
  //}
  100% {
    background-position: 100% 50%;
  }
}
.arrow-down {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #827717;
  font-size: 29px;
  cursor: pointer;
}
.disabled_scroll {
  display: none;
}
.cancel-filter {
  margin-top: 2px;
  margin-left: 5px;
}

.presets-container {
  height: 20px;
  margin: 0px;
  padding: 0px;
  display: flex;
  position: relative;
  top: -8px;
  left: -75px;
}
.pre-btn:focus {
  outline: none;
}
.pre-btn {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sub-menu-presets-tab {
  display: flex;
  flex-direction: row;
  padding-left: 2px;
  margin-left: 63px;
  border: none;
  top: -7px;
  background: none;
  position: relative;
}
.preset-tab {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  max-width: 52px;
  margin-top: 0px !important;
  margin-left: 3px;
}
.preset-tab:hover {
  background: #d7d7d7;
}
.preset-tab:active {
  background: #a8a5a5;
}
.preset-tab.active {
  background-color: #827717;
  color: #fff;
}
.preset-tab:focus {
  outline: none;
}
.stats-btn {
  color: #4275ec;
  font-weight: bold;
}
.top-bar {
  display: flex;
  justify-content: space-evenly;
  background-color: #efefef;
  width: 100%;
  height: 15px;
  font-size: 10px;
  position: absolute;
  top: 23px;
  left: 73px;
}
.inner-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
}
span.for-diff-in-days {
  padding-left: 8px;
}
.trans-chart {
  height: 160px !important;
  padding-top: 10px !important;
}
</style>
